module.exports = __webpack_public_path__ + "static/media/551JamesPBrawleyDrNW_2018-06-12_98.1ddbf02f.jpg";